<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnsendwln" @change="showUnsendwlnChange" active-text="显示未同步万里牛" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="显示未同步金蝶" inactive-text=""></el-switch>
<!-- 				<el-switch style="padding-left:20px" v-model="showtransferaccount" @change="showtransferaccountChange" active-text="显示转账单" inactive-text=""></el-switch> -->
			</el-header>
			<el-main class="main flex">
				<vxe-grid :id="reportName+'_list'" class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
					@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
				</vxe-grid>			
			</el-main>
		</el-container>
		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<receipt-index ref="receiptBox" :param="param" />
		<edit-index ref="rowedit" :row="currentrow" @success="success" />	
		<statistics-index ref="statistics" :transTime="transTime" @exportdetail="exportdetail" />	
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import exportMixins from '@_system/components/base/mixins/list/export.js'
	import exportTable from '@_system/components/export/index.vue'
	import receiptIndex from '@/views/main/paymentout/paymentapplication/lib/receipt/index.vue'
	import statisticsIndex from './lib/statistics/index.vue'
	import editIndex from './lib/edit/index.vue'
	export default {
		mixins: [reportBase, exportMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				showUnsendjindie:false,
				showUnsendwln:false,
				showtransferaccount:false,
				transTime: null,

				// footerField: [{
				// 	type: 'seq',
				// 	field: 'code',
				// 	title: '汇总',
				// }, {
				// 	type: 'field',
				// 	field: 'num',
				// 	toFixed: 1
				// }, {
				// 	type: 'field',
				// 	field: 'preamount',
				// 	toFixed: 4
				// }, {
				// 	type: 'field',
				// 	field: 'amount',
				// 	toFixed: 4
				// }],
				reportName: 'reconciliation_bankflow',
				windowName: '宁波付款明细',
				showFooter: false,
				exportRef: Math.random(),
				pagerConfig: {
					autoHidden: true,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500, 1000, 2000, 5000],
				},
				// pagerConfig: {
				// 	enabled: false,
				// },
				receiptType:'CD',
				loading: false,
				currentrow:null,
				param:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.report.reportlist(this.reportName,{
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
							bancktype:this.bancktype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},
				
			beforeCreateGrid(formConfig,columns,gridOptions ){
				gridOptions.id = 'nbreport_list'
				gridOptions.checkboxConfig = null
				columns.unshift({
					type: 'checkbox',
					title: '',
					field:'',
					fixed:'left',
					width:50
				})
				columns.forEach((item)=>{
					if(item.field=='serialNo'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.cdSign==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
								}
								if(row.cdSign==0){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
								}
								str.push(<span>{row.serialNo}</span>)
								return str
							}
						}
					}
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie){
									if(row.export_jindie_sucess == 1){
										return <span style="color:#67C23A;">已同步</span>
									}else{
										if(row.export_jindie_error){
											let error = row.export_jindie_error.map((item)=>{
												return item.Message
											})
											//console.log(row.export_jindie_error)
											return <span style="color:#F56C6C;">{error.join(',')}</span> 
										}else{
											return <span style="color:#F56C6C;">同步失败</span> 
							
										}									
									}
								}else{
									return <span style="color:#F56C6C;">未同步</span> 
								}
							}
						}
					}
					if(item.field=='export_wln'){
						item.slots = {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
					if(item.field=='img_file'){
						item.slots = {
							default:({row})=>{
								return 	row.img_file? <el-image style="width: 30px; height: 30px" src={row.img_file[0].path} preview-src-list={row.img_file.map((item)=>{
									return item.path
								})}></el-image> : ''
							}
						}
					}
				})
			},
			sendjindie(){
				let data =  this.$refs[this.reportName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendjindie({id:item.id}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			sendwln(){
				let data =  this.$refs[this.reportName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendwln({id:item.id}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})				
			},
			receipt(row) {
				this.param = {code:row.paymentapplicationcode}
				this.$nextTick(()=>{
					this.$refs.receiptBox.modalShow()
				})
				// this.currentrow = row
				// let handle = this.$loading()
				// this.$api.paymentapplication.getReceiptInfo({
				// 	supplierwlnid: row.purchasesupplierid,
				// 	id: row.paymentapplicationid,
				// 	type: row.ordertype
				// }).then((res) => {
				// 	this.receiptInfo = res
				// 	this.receiptType = row.ordertype
				// 	this.$loadingclose(handle)
				// 	this.$refs.receiptBox.modalShow()

				// },()=>{
				// 	this.$loadingclose(handle)
				// })
				
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement({
					id: row.id,
					wlnid: row.purchasesupplierid,
					purchasecode: row.serialNo
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			paymentsummary() {
				let form = this.$refs[this.reportName + '_list'].getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},

			edit(row){
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs[this.reportName + '_list'].getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			exportTable,
			receiptIndex,
			statisticsIndex,
			editIndex
		}
	}
</script>